var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2SlidingGateOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 22v29H26V26H10v-4H4v33h68V22h-6zM22 51H10V30h12v21zm-4-13h-4v-4h4v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C2_Sliding_gate_open.5fe5af96.svg";
export { SvgC2SlidingGateOpen as ReactComponent };